import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { isHoppyOrGamification } from "@util/Scripts";
import { ListScripts } from "./Lists/listScripts";
import { cloudGQLList } from "services/graphql/GraphQl";
import { setClickedRow } from "appRedux/actions/Actions";
import { getListWithUserCoordinates, saveFormV2, getForm } from "services/restAPI/RestApi";
import { getListV2 } from "../../../services/api/Api";
import { getList, getFilteredList, getPdf, getListProfiles } from "services/api/Api";
import { getListV3 } from "../../../services/restAPI/ListsV2";
import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { Select } from "antd";
import _ from "lodash";
import IntlMessages from "@util/IntlMessages";
import Widget from "components/Widget/Widget";
import MapComponent from "./Lists/MapComponent";
import ListCell from "./Lists/ListCell";
import ListSerieSelector from "./Lists/ListSerieSelector";
import ListEditableRow from "./Lists/ListEditableRow";
import ListExtraSettings from "./Lists/ListExtraSettings";
import ListSerieNameHeader from "./Lists/ListSerieNameHeader";
import ListSearchButtons from "./Lists/ListSearchButtons";
import "./Lists/mapComponent.less";
import "./list.less";
import { DragableBodyRow } from "./Lists/listDraggableRow";
import {
   Message,
   Spin,
   Card,
   Input,
   Pagination,
   DatePicker,
   Checkbox,
   Modal,
   Button,
} from "../../BP2Components";
import { getConnectionData } from "../../../util/Scripts";
import SummaryLabel from "../../Table/SummaryLabel";
import { Icon_Filter, Icon_Placefinder, Icon_Plus2 } from "../../BP2Components/Icons/icons";
import { decode } from "js-base64";
import moment from "moment";
import ExcelExportButton from "./Lists/ListExcelExportButton";
import ListGridNavWrapper from "../../../util/ListGridNavWrapper";
import { FormV3Context } from "../../../context/FormV3Context/FormV3Context";
import { getFormStructure } from "../../../services/restAPI/FormsV3";
import FormComplete from "../../FormsV2/FormComplete";
import { FormV3InModal } from "../FormsV3/FormV3InModal/FormV3InModal";
import Placefinder from "../Placefinder/Placefinder";

const { Option } = Select;

class CloudList extends React.Component {
   static contextType = FormV3Context;
   constructor(props) {
      super(props);
      this.widgetRef = React.createRef();
      this.state = {
         addItemFormId: null,
         addRowModalOpen: false,
         selectedRowKeys: [],
         invoicesList: [],
         isOpenList: true,
         name: "",
         columns: [],
         rows: [],
         page: 1,
         totalItems: null,
         selectedSerie: 0,
         defaultZoom: 14,
         editable: this.props.listWidgetSeries[0].listWidgetSerieSettings[0].addition,
         filteredRows: [],
         customFilterData: {
            searchText: null,
            searchedColumn: null,
            filteredListId: null,
         },
         empty: 0,
         showAllMapTasks: true,
         technamesPresenterForm: null,
         editFormError: false,
         mapMarkers: [],
         markersSerie: null,
         listProfiles: [],
         profileSelection: {
            selectedProfile: null,
            profiledListId: null,
         },
         mapHeight: ListScripts.getWidgetScreenHeight(),
         headerPosition: this.props?.showMap === true ? "bottom" : "center",
         listWindow: false,
         pointName: "",
         transport: [],
         loading: false,
         draggableMode: false,
         allActions: [],
         formId: null,
         radius: null,
         centerLocation: null,
         isPlaceFinderChatOpen: false,
         isPlacefinderJobRunning: false,
         selectedRowCoordinates: [],
         showUrlButton: false,
      };
   }

   inFlightKey = null;
   lastListKey = null;
   currentListKey = null;
   requestVersion = 0;

   lastFormId = null;
   formInFlight = false;

   lastHandledRefreshListRef = { current: null };

   componentDidMount() {
      this.requestAndFillList();
   }

   componentDidUpdate(prevProps, prevState) {
      if (
         prevProps?.showUrlButton !== this.props.showUrlButton ||
         prevProps?.urlColumn !== this.props.urlColumn ||
         prevProps?.ulrButtonTitle !== this.props.ulrButtonTitle ||
         prevProps.listId !== this.props.listId ||
         prevProps.page !== this.props.page ||
         prevState.editable !== this.state.editable ||
         prevProps.checkboxes !== this.props.checkboxes ||
         prevProps.isDownloadable !== this.props.isDownloadable ||
         prevProps.isCsvDownloadable !== this.props.isCsvDownloadable ||
         prevProps.ipp !== this.props.ipp ||
         prevProps.xs !== this.props.xs ||
         prevProps.sm !== this.props.sm ||
         prevProps.md !== this.props.md ||
         prevProps.lg !== this.props.lg ||
         prevProps.xl !== this.props.xl ||
         prevProps.localizationFieldName !== this.props.localizationFieldName ||
         prevProps.mapClickFilterColName !== this.props.mapClickFilterColName ||
         prevProps.mapPointColName !== this.props.mapPointColName ||
         prevProps.mapDistanceColName !== this.props.mapDistanceColName ||
         prevProps.mapAddressColName !== this.props.mapAddressColName ||
         prevState.defaultZoom !== this.props.defaultZoomLevel ||
         prevProps.viewListSerie !== this.props.viewListSerie ||
         prevProps.mapListSerie !== this.props.mapListSerie ||
         prevProps.mapIndependentSerie !== this.props.mapIndependentSerie ||
         prevProps?.showMap !== this.props?.showMap ||
         prevProps.maxDistanceToFilter !== this.props.maxDistanceToFilter ||
         prevProps.filterByLocation !== this.props.filterByLocation ||
         prevProps.setDistanceColumnHidden !== this.props.setDistanceColumnHidden ||
         prevState.page !== this.state.page ||
         JSON.stringify(prevProps.listWidgetSeries) !==
            JSON.stringify(this.props.listWidgetSeries) ||
         prevState.selectedSerie !== this.state.selectedSerie ||
         JSON.stringify(prevState.profileSelection) !==
            JSON.stringify(this.state.profileSelection) ||
         JSON.stringify(prevState.customFilterData) !==
            JSON.stringify(this.state.customFilterData) ||
         prevProps.searchParams !== this.props.searchParams ||
         prevProps.showChatButton !== this.props.showChatButton ||
         (prevProps.distanceToFilter !== this.props.distanceToFilter &&
            this.state.showAllMapTasks === true) ||
         prevState.selectedRowKeys !== this.state.selectedRowKeys
      ) {
         this.requestAndFillList();
      }
      if (prevProps.distanceToFilter !== this.props.distanceToFilter) {
         if (!this.state.showAllMapTasks) {
            this.switchToAllTaskSerie();
         }
      }
      if (
         JSON.stringify(prevProps.columnProperties) !== JSON.stringify(this.props.columnProperties)
      ) {
         this.setState({ columnProperties: this.props.columnProperties });
      }
      if (prevProps.listId !== this.props.listId) {
         this.setState({ columnProperties: [], columns: [] });
      }
      if (prevState.defaultZoom !== this.props.defaultZoomLevel) {
         this.setState({ defaultZoom: this.props.defaultZoomLevel });
      }
      this._forceRefreshFromContext();
   }

   _forceRefreshFromContext() {
      const ctx = this.context || {};
      const tableRefreshList = ctx.tableRefreshList || {};
      const setTableRefreshList = ctx.setTableRefreshList;

      if (this.lastHandledRefreshListRef.current === tableRefreshList) return;

      const currentSerie = this.getSerieById?.(this.state.selectedSerie);
      const currentListId = String(currentSerie?.listId || this.props.listId || "");

      const shouldRefreshList = !!currentListId && Object.hasOwn(tableRefreshList, currentListId);

      if (!shouldRefreshList) return;
      this.lastHandledRefreshListRef.current = tableRefreshList;
      this.requestAndFillList({ force: true });

      setTableRefreshList((prev) => {
         if (!Object.hasOwn(prev, currentListId)) return prev;
         const next = { ...prev };
         delete next[currentListId];
         return next;
      });
   }

   handleChangeRadius = (radiusValue, centerValue) => {
      this.setState({ radius: radiusValue, centerLocation: centerValue });
   };

   setIsPlaceFinderChatOpen = () => {
      this.setState((prevState) => ({ isPlaceFinderChatOpen: !prevState.isPlaceFinderChatOpen }));
   };

   setPlacefinderJobRunning = (isRunning) => {
      this.setState({ isPlacefinderJobRunning: !!isRunning });
   };

   buildListKey({ listId, page, itemsPP, listFilters, listSorters, profileId }) {
      const payload = { listId, page, itemsPP, listFilters, listSorters, profileId };
      return `list|${JSON.stringify(payload)}`;
   }

   requestAndFillList(options = {}) {
      const { force = false } = options;
      const { listWidgetSeries, mapListSerie, mapIndependentSerie } = this.props;
      const { selectedSerie, showAllMapTasks, markersSerie } = this.state;
      const selectedSerieObj = this.getSerieById(selectedSerie);
      this.setState({ empty: 0 }); //todo - ??? what is this
      if (selectedSerieObj?.query && selectedSerieObj.query.length > 30) {
         cloudGQLList(selectedSerieObj.query, this.state.page, 100000).then((res) => {
            const mappedResp = ListScripts.handleGraphQLResponse(selectedSerieObj.query, res);
            if (mappedResp) {
               const gqlRowsAndColumns = ListScripts.prepareGQLRowsAndColumns(
                  mappedResp,
                  this.props.intl,
                  this.getColumnSearchProps,
               );
               this.setState({
                  rows: gqlRowsAndColumns.rows,
                  totalItems: length,
                  name:
                     this.props.listWidgetSeries.length === 1
                        ? this.props.listWidgetSeries[0].name
                        : "",
                  columns: gqlRowsAndColumns.columns,
                  loading: false,
               });
            } else {
               this.setState({ totalItems: 0 });
            }
         });
      } else if (
         (selectedSerieObj?.listId && Number.isInteger(+selectedSerieObj?.listId)) ||
         (selectedSerieObj?.listId && selectedSerieObj?.listId.length < 35)
      ) {
         // Show map serie when set
         let listId = selectedSerieObj.listId;
         if (showAllMapTasks) {
            listId = ListScripts.switchListIdForMapNeeds(
               selectedSerieObj.listId,
               markersSerie,
               listWidgetSeries,
               mapListSerie,
               mapIndependentSerie,
               selectedSerieObj,
            );
         }
         const urlParams = new URLSearchParams(window.location.search);
         const safeParse = (value) => {
            try {
               return JSON.parse(decodeURIComponent(value));
            } catch {
               return null;
            }
         };
         const listFilters = safeParse(urlParams.get("listFilters"))?.[this.props.widgetId];
         const listSorters = safeParse(urlParams.get("listSorters"))?.[this.props.widgetId];
         const itemsPP = this.getSerieById(this.state.selectedSerie)?.itemsPerPage;
         const profileId = this.state.profileSelection?.selectedProfile?.id ?? null;
         const key = this.buildListKey({
            listId,
            page: this.state.page,
            itemsPP,
            listFilters,
            listSorters,
            profileId,
         });
         if (!force && (this.inFlightKey === key || this.lastListKey === key)) return;
         if (force) {
            this.inFlightKey = null;
            this.lastListKey = null;
         }
         this.requestVersion += 1;
         this.currentListKey = key;
         this.inFlightKey = key;
         return this.getBPList(listId, selectedSerieObj.itemsPerPage);
      }
   }

   actionsColumn = (position) => {
      this.setState({ position: position });
   };
   getListData = async (listId, page, itemsPP, data, v2, sortValues) => {
      let listResponse;
      // Because backend can't do normal column attribute nad they give us Model.Attribute we need to split it and take only attribute
      const sortValuesForBackend =
         sortValues?.columnAttribute && sortValues?.direction
            ? {
                 ...sortValues,
                 columnAttribute: sortValues.columnAttribute.split(".")[1],
              }
            : null;

      try {
         this.setState({ loading: true });
         const isV3 = listId.toString().length > 10;
         if (Number.isInteger(+listId) && !isV3) {
            if (v2) {
               listResponse = await getListV2(
                  listId,
                  page,
                  itemsPP,
                  data,
                  null,
                  sortValuesForBackend,
               );
            } else {
               listResponse = await getList(listId, page, itemsPP, data, sortValuesForBackend);
            }
         } else {
            const resp = await getListV3(listId, page, itemsPP, data);
            listResponse = this.transformNewListResponseToOld(resp);
            listResponse = { ...listResponse, status: resp?.status ?? 200 };
         }
      } catch (err) {
         console.error(err);
         throw err;
      } finally {
         this.setState({ loading: false });
      }
      return listResponse;
   };
   transformNewListResponseToOld = (resp) => {
      const response = resp;
      if (response?.data?.columns && response.data.data) {
         const fileColumnLabels = new Set();
         response.data?.columns?.forEach((column) => {
            column.options.techName = column.techName;
            column.options.enumType = column.meta?.type ?? "text";
            column.options.hidden = column.options.visible ? "0" : "1";
            column.options.precision = column.options.precision ?? "0";
            column.options.sumAllRecords = column.options.sumAllValues ? 1 : 0;
            column.options.sumColumn = 0;
            column.options.visible = column.options.visible ? 1 : 0;
            column.options.visibleOnMobile = 1;
            if (column.meta?.type === "File") {
               fileColumnLabels.add(column.label);
            }
         });
         response.data.data.forEach((row, i) => {
            row.api_rowMetaData = { recordId: row.ID ? row.ID : i };
            // Convert new multiple object values from java to simple string with new lines
            Object.keys(row).forEach((key) => {
               if (row[key] && typeof row[key] === "object" && !fileColumnLabels.has(key)) {
                  const values = Object.keys(row[key]).map((innerKey) => {
                     return `${innerKey}: ${row[key][innerKey]} \n\n`;
                  });
                  const multipleCellValue = values.toString().replaceAll(",", "");
                  row[key].value = multipleCellValue;
               }
            });
         });
         response.data.meta.totalItemsCount = response.data.meta.totalElements;
         response.data.meta.displayFormChildId = "0";
         response.data.meta.model = "";
         response.data.meta.name = "PoC List";
         response.data.meta.previewItemFormChildId = "0";
      }
      response.data.default = response.data;
      response.data.getPublicList = response.data;
      return response;
   };
   getBPList = (listId, itemsPP) => {
      const {
         mapIndependentSerie,
         localizationFieldName,
         currentLocation,
         setDistanceColumnHidden,
         mapListSerie,
         distanceToFilter,
      } = this.props;
      const { page, showAllMapTasks } = this.state;
      const selectedSerieObj = this.getSerieById(this.state.selectedSerie);
      const urlParams = new URLSearchParams(window.location.search);

      const sortersParam = urlParams.get("listSorters");
      const currentListUrlSorters = sortersParam
         ? JSON.parse(decodeURIComponent(sortersParam))
         : null;

      const sortValues = currentListUrlSorters?.[this.props.widgetId];

      if (Number.isInteger(+listId)) {
         getListProfiles(listId).then((res) => {
            if (res?.data?.getProfiles?.length) {
               this.setState({ listProfiles: res.data.getProfiles });
            }
         });
      }

      let profileId = null;
      let profileSelection = this.state.profileSelection;
      const expectedKey = this.currentListKey;
      const expectedVersion = this.requestVersion;
      const finalizeFlight = () => {
         if (this.inFlightKey === expectedKey) this.inFlightKey = null;
      };

      const runRequest = (promise) =>
         promise
            .then((res) => {
               if (!res) return 500;

               this.handleListResponse(res, expectedKey, expectedVersion);

               if (typeof res?.status === "number") return res.status;

               return 200;
            })
            .catch((err) => {
               console.error(err);
               return 500;
            })
            .finally(() => {
               finalizeFlight();
            });

      // Check if profile was selected on actual list
      if (profileSelection.profiledListId === listId && profileSelection.selectedProfile?.id) {
         profileId = profileSelection.selectedProfile.id;
      }
      if (
         /* filterByLocation */ false &&
         showAllMapTasks &&
         (selectedSerieObj.name === mapListSerie || selectedSerieObj.name === mapIndependentSerie)
      ) {
         navigator.geolocation.getCurrentPosition((position) => {
            const stringPosition = position.coords.latitude + ", " + position.coords.longitude;
            getListWithUserCoordinates(
               localizationFieldName,
               currentLocation ? currentLocation : stringPosition,
               distanceToFilter,
               setDistanceColumnHidden,
               itemsPP,
               listId,
               profileId,
               page,
            )
               .then((res) => this.handleListResponse(res, expectedKey, expectedVersion))
               .catch((err) => console.error(err))
               .finally(() => {
                  if (this.inFlightKey === expectedKey) this.inFlightKey = null;
               });
         });
      } else if (
         this.state.customFilterData.searchText === null ||
         this.state.customFilterData.searchText === ""
      ) {
         let connectionData;
         if (window?.location) {
            connectionData = getConnectionData(this.props.widgetId);
         }

         if (connectionData) {
            return runRequest(
               this.getListData(listId, page, itemsPP, connectionData, true, sortValues),
            );
         } else if (urlParams.get("listFilters")) {
            try {
               const currentListUrlFilters = JSON.parse(
                  decodeURIComponent(urlParams.get("listFilters")),
               );
               return runRequest(
                  this.getListData(
                     listId,
                     page,
                     itemsPP,
                     currentListUrlFilters[this.props.widgetId],
                     true,
                     sortValues,
                  ),
               );
            } catch (err) {
               console.error("Error in initial render with filter in URL", err);
               finalizeFlight();
               return Promise.resolve(500);
            }
         } else {
            return runRequest(
               this.getListData(listId, page, itemsPP, profileId, false, sortValues),
            );
         }
      } else {
         let filterCol = this.state.customFilterData.searchedColumn;
         let filterValue = this.state.customFilterData.searchText;

         return runRequest(
            getFilteredList(listId, page, itemsPP, filterCol, filterValue, profileId, sortValues),
         );
      }
   };
   getListForm = (meta) => {
      const id = meta.global?.presenterFormId ?? meta?.displayFormChildId;
      const isV3 = id.toString().length > 10;
      if (!id) return;
      if (this.formInFlight || this.lastFormId === id) return;
      this.formInFlight = true;
      const getFormData = isV3 ? getFormStructure(id) : getForm(id, null, null, null, null, true);
      getFormData
         .then((res) => {
            let technamesPresenterForm = [];
            const data = isV3 ? res.data : res.data.default.mainForm;
            if (isV3) {
               technamesPresenterForm = (data?.fields ?? []).map((field) => {
                  const techname = field?.hid ?? field?.id ?? null;
                  const attribute =
                     field?.modelField?.name ?? field?.placeholder ?? field?.label ?? field?.id;
                  return {
                     techname,
                     attribute,
                  };
               });
            } else {
               for (const [key, value] of Object.entries(data.forms_data.tab[0].elements)) {
                  technamesPresenterForm.push({
                     techname: value.tech_name,
                     attribute: value.atr,
                     UIP_ID: value.object.UIP_ID,
                     options: value.options,
                     sqlValues: value.sqlValues,
                     label: value.label,
                     UIP_EDYT: value.object.UIP_EDYT,
                  });
               }
            }
            // PresenterFormId should be named 'showFromId' in our code, becasue we are using it to edit list, not show it, so keep that in mind that presenter and show formid are different forms.
            this.setState({
               presenterForm: data.forms_data.tab[0] ?? data,
               technamesPresenterForm: technamesPresenterForm,
               presenterFormId: id,
               formKey: data?._formKey ?? "",
               editFormError: false,
            });
            this.lastFormId = id;
         })
         .catch(() => {
            this.setState({
               editFormError: true,
            });
         })
         .finally(() => {
            this.formInFlight = false;
         });
   };

   handleSelectOne = (recordId, checked) => {
      this.setState((prevState) => {
         const selectedRowKeys = prevState.selectedRowKeys ?? [];

         let nextSelected;
         if (checked) {
            nextSelected = selectedRowKeys.includes(recordId)
               ? selectedRowKeys
               : [...selectedRowKeys, recordId];
         } else {
            nextSelected = selectedRowKeys.filter((key) => key !== recordId);
         }

         return { selectedRowKeys: nextSelected };
      });
   };

   handleSelectAll = (checked) => {
      this.setState((prevState) => {
         const rows = prevState.rows || [];
         const newSelected = checked ? rows.map((row) => row.api_rowMetaData.recordId) : [];
         return { selectedRowKeys: newSelected };
      });
   };

   pickFormId = (value) => (value != null && value.toString() !== "0" ? value : null);

   handleListResponse = (res, expectedKey, expectedVersion) => {
      if (expectedKey && expectedKey !== this.currentListKey) return;
      if (expectedVersion !== undefined && expectedVersion !== this.requestVersion) return;

      const responseData = res?.data?.getPublicList ?? res?.data?.default ?? {};
      const { actions = [], columns = [], data = [], meta = {} } = responseData;
      const selectedSerieObj = this.getSerieById(this.state.selectedSerie);
      let invoice = [];

      if (res?.data && responseData && data) {
         data.forEach((el) => {
            let obj = {};
            obj[el.ID] = el.Plik;
            invoice.push(obj);
         });
         data.map((el) => delete el.Faktura);
         this.setState({ invoicesList: invoice, transport: [meta.transport] });

         // get list form for php list - transport field is only in old php lists meta data
         if (meta.transport) {
            this.getListForm(meta);
         }
         const preparedColumns = [];
         const actionsColumnRight =
            this.getSerieSetting("setActionsColumnRight") === true ? true : false;
         const urlParams = new URLSearchParams(window.location.search);

         if (Object.values(actions).length > 0 && selectedSerieObj.listId?.length > 10) {
            columns.unshift({
               title: "Actions",
               dataIndex: "api_recordactions",
               label: "api_recordactions",
               options: {
                  visible: 1,
                  hidden: "0",
               },
            });
         }
         columns.forEach((column, index) => {
            if (
               column.label.toLowerCase() === "api_recordactions" &&
               actions.length < 1 &&
               !this.props.showChatButton
            ) {
               return;
            }
            const optionsArray = [];
            if (column?.options?.values) {
               for (const [key, value] of Object.entries(column.options.values)) {
                  optionsArray.push({
                     key: column.options.extraSearch ? "extra:" + column.options.extraSearch : key,
                     label: value,
                     value: key,
                     option: value,
                  });
               }
            }
            const columnSettings = selectedSerieObj.columnProperties?.[index];

            // Here we establish the current filters and sorters for the list
            const currentListUrlFilters = JSON.parse(
               decodeURIComponent(urlParams.get("listFilters")),
            )?.[this.props.widgetId];
            const currentListUrlSorters = JSON.parse(
               decodeURIComponent(urlParams.get("listSorters")),
            )?.[this.props.widgetId];

            const columnLCLabel = column.label.toLowerCase();
            let obj = {
               title:
                  columnLCLabel === "api_recordactions"
                     ? isHoppyOrGamification() && <IntlMessages id="list.header.actions" />
                     : column.label,
               dataIndex: columnLCLabel,
               attribute: column?.attribute,
               techName: column?.options?.techName,
               label: column?.label,
               hidden: column?.options?.hidden,
               enumType: column?.options?.enumType ? column.options.enumType : null,
               visible: column?.options?.visible,
               precision: column?.options?.precision,
               key: column?.label,
               sort: column?.sort,
               fixed: columnLCLabel == "api_rowmetadata" ? this.state?.position : false,
               width: columnLCLabel == "api_rowmetadata" ? 1 : null,
               ...this.getColumnSearchProps(columnLCLabel, column?.options?.techName, column),
               extraSearch: column?.options?.extraSearch,
               filteredValue: currentListUrlFilters?.[column?.options.techName]
                  ? [currentListUrlFilters[column?.options?.techName]]
                  : [],
               defaultSortOrder:
                  currentListUrlSorters?.columnAttribute === column?.attribute &&
                  currentListUrlSorters?.direction
                     ? currentListUrlSorters.direction === "ASC"
                        ? "ascend"
                        : "descend"
                     : null,
               render: (text, record, index) =>
                  this.renderCell(
                     text,
                     record,
                     meta.model,
                     columnLCLabel,
                     actions[index]?.length > 0 ? actions[index] : actions,
                     responseData,
                     columnSettings,
                     column.options.enumType ? column.options.enumType : null,
                     column?.options?.techName,
                  ),
            };

            if (columnLCLabel === "api_recordactions") {
               obj.filterDropdown = false;
            }

            if (columnLCLabel === "api_checkbox") {
               obj.hidden = true;
               obj.visible = 0;
            }

            if (
               !preparedColumns.find((col) => col.label === obj.label) ||
               !preparedColumns.find((col) => col.options?.techName === obj.techName)
            ) {
               preparedColumns.push(obj);
            }
         });

         let emptyValue = 0;
         let rowsTable = data.map((row) => {
            const obj = {};
            preparedColumns.forEach((column) => {
               const rowData =
                  column?.enumType && column?.enumType === "date" && row[column.label] !== null
                     ? row[column.label].substring(0, 10)
                     : row[column.label] !== null
                       ? row[column.label]
                       : "";
               if (typeof row[column.label] === "string") {
                  let rowValue = Number(row[column.label]);
                  // This has to check if rowValue is an empty string or not, because Number() converts empty string to 0
                  if (
                     row[column.label] &&
                     column.precision &&
                     row[column.label].length > 0 &&
                     column.enumType !== "text" &&
                     !isNaN(rowValue)
                  ) {
                     obj[column.dataIndex.toLowerCase()] = rowValue
                        .toFixed(column.enumType === "int" ? 0 : column.precision)
                        .toString();
                  } else {
                     obj[column.dataIndex.toLowerCase()] = rowData;
                  }
               } else {
                  obj[column.dataIndex.toLowerCase()] = rowData;
               }
               obj["key"] = data.indexOf(row);
               obj["_sysRecordId"] = row?.api_rowMetaData?.recordId;
               obj["api_rowMetaData"] = { recordId: row?.api_rowMetaData?.recordId };
               if (column.dataIndex === "api_rowmetadata") {
                  const index = data.indexOf(row);
                  const data = data[index];
                  if (data.api_rowMetaData && data.api_rowMetaData.recordActions.length === 0) {
                     emptyValue += 1;
                  }
               }
            });
            // todo - what is this for?
            if (emptyValue == data.length) {
               preparedColumns.shift();
            }
            return obj;
         });

         // After mapping the rowsTable, we need to filter out the invalid rows.
         // TODO: after we change using keys in lists from labels to technames, refactor it to just filter out
         // values from proper technames
         rowsTable = rowsTable.filter((row) => row !== undefined);
         this.setState({ empty: emptyValue });

         if (data.length > 0) {
            rowsTable.forEach((row) => {
               preparedColumns.forEach((col) => {
                  let rowName = row[col.label.toLowerCase()];
                  if (rowName?.exportedValue) {
                     if (rowName.exportedValue.SLO_NAZWA !== undefined) {
                        row[col.label.toLowerCase()] = rowName.exportedValue.SLO_NAZWA;
                     } else {
                        // This is quick fix for backend.
                        row[col.label.toLowerCase()] =
                           rowName.exportedValue?.["concat(dep.name, '')"] ??
                           rowName.exportedValue.slo_nazwa;
                     }
                  }
               });
            });
         }

         const hasLocal = "addItemFormId" in meta;

         const addItemFormId = hasLocal
            ? this.pickFormId(meta.addItemFormId)
            : this.pickFormId(meta.global?.addItemFormId);
         this.setState({
            rows: rowsTable,
            allActions: actions,
            filteredRows: rowsTable,
            totalItems: meta.totalItemsCount,
            totalPages: meta.totalPages,
            name: meta.name,
            model: meta.model,
            meta,
            columns: preparedColumns,
            loading: false,
            formId: meta.displayFormChildId ?? meta?.global?.presenterFormId,
            addItemFormId: addItemFormId,
         });
         if (
            (this.state.showAllMapTasks === true &&
               this.props.mapListSerie &&
               this.props.mapListSerie !== "-") ||
            (this.state.showAllMapTasks === true &&
               this.props.mapIndependentSerie &&
               this.props.mapIndependentSerie !== "-")
         ) {
            this.setState({
               mapMarkers: rowsTable,
               markersSerie: this.props.mapListSerie,
            });
         }
         this.cacheData = rowsTable.map((item) => ({ ...item }));
         this.lastListKey = this.currentListKey;
      }
      this.lastListKey = expectedKey || this.currentListKey;
      this.inFlightKey = null;
   };

   shouldRenderSearchDropdown(label, optionsArray) {
      if (optionsArray.length === 0) {
         return this.getColumnSearchProps(label);
      }
   }

   renderEditableRows = () => {
      return {
         title: "",
         dataIndex: "operation",
         width: 1,
         fixed: "left",
         render: (text, record) => {
            return (
               <ListEditableRow
                  record={record}
                  cancel={this.cancel}
                  save={this.save}
                  edit={this.edit}
               />
            );
         },
      };
   };
   switchToggle = () => {
      this.requestAndFillList({ force: true });
   };
   handleSerieChange = (serieId) => {
      const clickedSerie = this.props.listWidgetSeries.find((serie) => serie.id === serieId);
      this.setState({ selectedSerie: clickedSerie.listWidgetSerieKey });
   };

   renderInputComponent = (
      column,
      setSelectedKeys,
      selectedKeys,
      confirm,
      dataIndex,
      columnTechname,
   ) => {
      // Normally, we should check the column filter type using 'searchType,' but Dominika insists on making an exception for this one and using 'enumType' instead.
      if (column?.options?.enumType === "date" || column?.options?.enumType === "date_time") {
         return (
            <DatePicker
               onChange={(date) => {
                  setSelectedKeys(
                     moment(date).format("YYYY-MM-DD") ? [moment(date).format("YYYY-MM-DD")] : [],
                  );
               }}
            />
         );
      } else if (column?.options?.searchType === "drop_down_list" && column?.options?.values) {
         const convertedValues = ListScripts.convertValuesToSameStructure(
            column.options.values,
            column.options.enumType,
         );

         return (
            <Select
               onChange={(e) => setSelectedKeys(e ? [e] : [])}
               value={selectedKeys[0]}
               style={{
                  width: 188,
                  marginBottom: 8,
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
               }}
               dropdownStyle={{ maxWidth: 300 }}
            >
               {convertedValues.map((option) => {
                  return (
                     <Option
                        value={option.label}
                        key={option.value}
                        name={option.label}
                        style={{
                           whiteSpace: "normal",
                           wordWrap: "break-word",
                        }}
                     >
                        {option.label}
                     </Option>
                  );
               })}
            </Select>
         );
      } else if (
         column?.options?.searchType === "search_drop_down_list" &&
         column?.options?.values
      ) {
         const convertedValues = ListScripts.convertValuesToSameStructure(
            column.options.values,
            column.options.enumType,
         );

         return (
            <Select
               showSearch
               placeholder={this.props.intl.formatMessage({ id: "filter.search" })}
               onChange={(e) => setSelectedKeys(e ? [e] : [])}
               value={selectedKeys[0]}
               style={{
                  width: 188,
                  marginBottom: 8,
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
               }}
               dropdownStyle={{ maxWidth: 300 }}
            >
               {convertedValues.map((option) => {
                  return (
                     <Option
                        value={option.label}
                        key={option.value}
                        name={option.label}
                        style={{
                           whiteSpace: "normal",
                           wordWrap: "break-word",
                        }}
                     >
                        {option.label}
                     </Option>
                  );
               })}
            </Select>
         );
      } else {
         return (
            <Input
               ref={(node) => {
                  this.searchInput = node;
               }}
               placeholder={this.props.intl.formatMessage({ id: "filter.search" })}
               value={
                  selectedKeys[0]?.match(/^b64:/)
                     ? decode(selectedKeys[0]?.substring(4))
                     : selectedKeys[0]
               }
               onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() =>
                  this.handleSearch(selectedKeys, confirm, dataIndex, columnTechname)
               }
               style={{ width: 188, marginBottom: 8, display: "block" }}
            />
         );
      }
   };

   getColumnSearchProps = (dataIndex, columnTechname, column) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8, width: 205 }}>
            <>
               {/* in this finction we render all of the itputs (or selects) to get filter value from user */}
               {this.renderInputComponent(
                  column,
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  dataIndex,
                  columnTechname,
               )}

               <ListSearchButtons
                  selectedKeys={selectedKeys}
                  confirm={confirm}
                  dataIndex={dataIndex}
                  columnTechname={columnTechname}
                  handleSearch={this.handleSearch}
                  handleReset={this.handleReset}
                  clearFilters={clearFilters}
               />
            </>
         </div>
      ),
      filterIcon: () => (
         <i>
            <Icon_Filter />
         </i>
      ),
      // This is needed so filtering on SQL and dictionary fields work. Filtering now is done entirely on backend
      onFilter: () => true,
      onFilterDropdownVisibleChange: (visible) => {
         if (visible) {
            setTimeout(() => this?.searchInput?.select());
         }
      },
      render: (text) => text,
   });

   // FILTERING
   handleSearch = (selectedKeys, confirm, dataIndex, columnTechname) => {
      confirm();
      ListScripts.handleAddFilterToUrl(this.props.widgetId, columnTechname, selectedKeys?.[0]);
   };

   handleReset = (clearFilters, columnTechname) => {
      clearFilters();
      ListScripts.handleDeleteFilterFromUrl(this.props.widgetId, columnTechname);
   };

   switchToWindowTaskSerie = (address) => {
      this.setState({
         mapHeight: ListScripts.getWidgetScreenHeight(),
         pointName: address,
      });
   };
   switchToAllTaskSerie = () => {
      const vh =
         this.state.headerPosition === "bottom" ? ListScripts.getWidgetScreenHeight() : "40vh";
      if (this.state.listWindow === true) {
         this.setState({ rows: null, totalItems: null });
      }
      this.setState({ listWindow: false, mapHeight: vh });
      this.resetCustomFilter();
      let allTaskSerieId = null;
      if (this.props.mapListSerie) {
         this.props.listWidgetSeries.forEach((serie, i) => {
            if (this.props.mapListSerie === serie.name) {
               allTaskSerieId = serie.id;
            }
         });
      }
      if (this.props.mapIndependentSerie === this.getSerieById(this.state.selectedSerie).name) {
         allTaskSerieId = this.getSerieById(this.state.selectedSerie).id;
      }
      if (allTaskSerieId) {
         this.setState({ showAllMapTasks: true });
         this.handleSerieChange(allTaskSerieId);
      }
   };
   resetCustomFilter = () => {
      this.setState({
         customFilterData: {
            searchText: null,
            searchedColumn: null,
            filteredListId: null,
         },
      });
   };
   downloadPDF = () => {
      const ids = ListScripts.handlePDF(this.state.invoicesList);
      ids?.forEach((ids) => {
         getPdf(ids.id, ids.name, ids.gdtoken);
      });
   };

   renderCell(
      text,
      record,
      model,
      column,
      actions,
      listResponse,
      columnSettings,
      enumType,
      techName,
   ) {
      let isEditable = record.editable;
      const clientCoordinates = !!this.props.localizationFieldName
         ? this.props.localizationFieldName.toLowerCase()
         : null;
      if (text && text.recordActions) {
         isEditable = false;
      }
      let listCellValue = text;
      if (column === "api_recordactions" && actions?.length > 0) {
         listCellValue = this.mapToActions(text, actions);
      }
      if (Array.isArray(actions) && actions.length > 0 && actions.every(Array.isArray)) {
         actions = actions[record.api_rowMetaData.recordId];
      }
      const selectedSerieObj = this.getSerieById(this.state.selectedSerie);
      return (
         <ListCell
            urlButton={{
               showUrlButton: this?.props?.showUrlButton,
               urlColumn: {
                  techName: this?.props?.ulrButtonTitle,
                  label: this?.state?.columns?.find(
                     (column) => column?.techName === this?.props?.urlColumn,
                  )?.dataIndex,
               },
               ulrButtonTitle: this?.props?.ulrButtonTitle,
            }}
            currentSheet={this.props.currentSheet}
            isChatButtonVisible={this.props.showChatButton}
            columns={this.state.columns}
            board={this.props.board}
            widgetId={this.props.widgetId}
            editable={isEditable}
            toggle={this.switchToggle}
            originalActions={actions}
            value={listCellValue}
            row={{
               ...record,
               clientCoordinates: !!clientCoordinates && record[clientCoordinates],
            }}
            center={this.getSerieSetting("centerCols")}
            align={columnSettings?.alignment}
            imageDownloadAvailable={columnSettings?.imageDownloadAvailable}
            imageWidth={columnSettings?.imageWidth}
            model={model}
            singleColumn={column}
            onChange={(value) => this.handleChange(value, record.key, column)}
            listResponse={listResponse}
            editFormError={this.state.editFormError}
            technamesPresenterForm={this.state.technamesPresenterForm}
            enumType={enumType}
            techName={techName}
            listId={selectedSerieObj.listId}
         />
      );
   }

   mapToActions = (labels, actions) => {
      if (labels && actions) {
         return actions.map((action, index) => {
            return labels.some((label) => label === action?.label) && actions[index];
         });
      }
   };
   handleChange = (value, key, column) => {
      const newData = [...this.state.rows];
      const target = newData.find((item) => key === item.key);
      if (target) {
         target[column] = value;
         this.setState({ rows: newData });
      }
   };
   edit = (key) => {
      const newData = [...this.state.rows];
      const target = newData.find((item) => key === item.key);
      if (target) {
         target.editable = true;
         this.setState({ rows: newData });
      }
   };
   save = (key) => {
      const newData = [...this.state.rows];
      const target = newData.find((item) => key === item.key);
      if (target) {
         delete target.editable;
         this.setState({ rows: newData });
         this.cacheData = newData.map((item) => ({ ...item }));
      }
      const selectedValues = _.omit(newData[key], ["api_rowmetadata", "operation", "key"]);
      const columnsCopy = [...this.state.columns];
      columnsCopy.splice(0, 1);
      this.saveData(columnsCopy, selectedValues);
   };
   saveData = (columns, values) => {
      Message.loading(this.props.intl.formatMessage({ id: "form.isProcessing" }), 0);
      let fieldsValues = {};
      columns.forEach((column) => {
         const fieldValue = values[column.dataIndex];
         if (typeof fieldValue === "object") {
            if (fieldValue.value) {
               fieldsValues[column.techName] = fieldValue.value;
               return;
            }

            if (fieldValue?.altUrl || fieldValue?.altUrl1 || fieldValue?.fileUrl) {
               fieldsValues[column.techName] =
                  fieldValue.altUrl ?? fieldValue?.altUrl1 ?? fieldValue?.fileUrl;
               return;
            }
         }
         fieldsValues[column.techName] = fieldValue;
      });
      saveFormV2(this.state.presenterFormId, this.state.formKey, fieldsValues)
         .then(() => {
            Message.destroy();
            Message.success(this.props.intl.formatMessage({ id: "global.saved" }));
         })
         .catch(() => {
            Message.destroy();
            Message.error(this.props.intl.formatMessage({ id: "form.errorWhileSaving" }));
         });
   };
   cancel = (key) => {
      const newData = [...this.state.rows];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
         Object.assign(target, this.cacheData.filter((item) => key === item.key)[0]);
         delete target.editable;
         this.setState({ rows: newData });
      }
   };
   onSelectChange = (selectedRowKeys, invoicesList) => {
      this.setState({ selectedRowKeys, invoicesList });
   };
   getObjectFromArrayByName = (attributeFilter, filterValue, list, extraSearch) => {
      // todo - wtf is this function
      const attr = attributeFilter.split(".");
      const keys = Object.keys(list);
      // list contains modified object {model:{attribute:value}} so attributeFilter and filterValue needs to be modified too (filterValue is usually nested array)
      if (keys.length === 0) {
         list[attr[0]] = {};
         if (Array.isArray(filterValue)) {
            filterValue.map((filter) => {
               if (Array.isArray(filter)) {
                  if (filter.length === 0) {
                     delete list[attr[0]][attr[1]];
                  } else {
                     ListScripts.setValueInFilter(filter[0], list, attr, extraSearch);
                  }
               } else {
                  ListScripts.setValueInFilter(filter, list, attr, extraSearch);
               }
            });
         } else {
            ListScripts.setValueInFilter(filterValue, list, attr, extraSearch);
         }
      } else {
         const findKey = keys.find((key) => key === attr[0]);
         if (findKey) {
            if (Array.isArray(filterValue[0])) {
               if (filterValue[0].length === 0) {
                  delete list[attr[0]][attr[1]];
               } else ListScripts.setValueInFilter(filterValue[0][0], list, attr, extraSearch);
            } else ListScripts.selectFilterMethod(filterValue, list, attr, extraSearch);
         } else {
            list[attr[0]] = {};
            if (Array.isArray(filterValue)) {
               filterValue.map((filter) => {
                  ListScripts.selectFilterMethod(filter, list, attr, extraSearch);
               });
            } else {
               ListScripts.selectFilterMethod(filterValue, list, attr, extraSearch);
            }
         }
      }
      // when filterValue has no value in nested array I delete object {model:{attribute:value}}
      keys.map((key) => {
         if (Object.keys(list[key]).length === 0) {
            delete list[key];
         }
      });
      return list;
   };

   handleChangeTable = (pagination, filters, sorter, extra) => {
      this.setState({ filteredRows: extra.currentDataSource });
      const copyFilters = {};
      const selectedSerieObj = this.getSerieById(this.state.selectedSerie);
      const filtersKeys = Object.keys(filters);
      filtersKeys.map((filter) => {
         this.state.columns.find((col) => {
            if (col.label === filter) {
               const attributeKey = col.attribute || col.techName;
               if (filters[filter].length !== 0 && attributeKey) {
                  this.getObjectFromArrayByName(
                     attributeKey,
                     filters[filter],
                     copyFilters,
                     col.extraSearch,
                  );
               }
            }
         });
      });
      this.setState({ filteredRows: extra.currentDataSource }, () => {
         this.getBPList(selectedSerieObj.listId, +selectedSerieObj.itemsPerPage);
      });
   };

   setSelectedProfile = (profile) => {
      const actualListId = this.getSerieById(this.state.selectedSerie).listId;
      this.setState({
         profileSelection: {
            selectedProfile: profile,
            profiledListId: actualListId,
         },
      });
   };

   getSerieById = (serieId) => {
      let searchedSerie;
      if (this.props.listWidgetSeries && this.props.listWidgetSeries[0]) {
         searchedSerie = this.props.listWidgetSeries.find(
            (serie) => serieId == serie.listWidgetSerieKey,
         );
         if (!searchedSerie) {
            searchedSerie = this.props.listWidgetSeries[0];
         }
      }
      return searchedSerie;
   };

   getSerieSetting = (settingName) => {
      let set = false;
      if (
         this.props.listWidgetSeries &&
         this.getSerieById(this.state.selectedSerie)?.listWidgetSerieSettings
      ) {
         this.getSerieById(this.state.selectedSerie).listWidgetSerieSettings.forEach((setting) => {
            if (setting.label === settingName && setting.addition === true) {
               set = true;
            }
         });
      }
      return set;
   };

   hasAddItemForm = () => {
      return this.state.addItemFormId;
   };

   handleMapHeight = (e) => {
      if (
         e.target &&
         !e.target.classList.contains("hide-map-icon") &&
         !e.target.classList.contains("hide-map-icon-img")
      ) {
         if (this.props?.showMap === true && this.state.headerPosition !== "top") {
            if (this.state.mapHeight === "40vh") {
               this.setState({
                  mapHeight: ListScripts.getWidgetScreenHeight(),
                  headerPosition: "bottom",
               });
            } else {
               this.setState({ mapHeight: "40vh", headerPosition: "center" });
            }
         }
      }
      this.setState((prevState) => ({ ...prevState, isOpenList: !prevState.isOpenList }));
   };
   toggleMap = () => {
      if (this.state.headerPosition === "bottom" || this.state.headerPosition === "center") {
         this.setState({ headerPosition: "top" });
      } else if (this.state.headerPosition === "top") {
         if (this.state.mapHeight === ListScripts.getWidgetScreenHeight()) {
            this.setState({ headerPosition: "bottom" });
         } else {
            this.setState({ headerPosition: "center" });
         }
      }
   };
   setCustomFilter = (colName, value, listId) => {
      if (colName && value && colName !== "" && value !== "") {
         this.setState({
            customFilterData: {
               searchText: value,
               searchedColumn: colName,
               filteredListId: listId,
            },
         });
      }
   };
   setProfile = (profile) => {
      this.setState({ loading: true });
      this.setState({
         profileSelection: {
            profiledListId: this.getSerieById(this.state.selectedSerie).listId,
            selectedProfile: profile,
         },
      });
   };
   setDraggableMode = (checked) => {
      this.setState({ draggableMode: checked });
   };

   components = {
      body: {
         row: DragableBodyRow,
      },
   };
   moveRow = (dragIndex, hoverIndex) => {
      const items = [...this.renderFilteredRows(this.state.rows)];
      const item = items.splice(dragIndex, 1)[0];
      items.splice(hoverIndex, 0, item);
      this.setState({ rows: items });
   };

   handleRowClick = (record, rowIndex, event, isAdding) => {
      const locFieldName = this.props.localizationFieldName?.toLowerCase();
      const rawCoordinates = locFieldName ? record[locFieldName] : null;

      let coordinates = null;
      if (rawCoordinates) {
         const parts = String(rawCoordinates).replaceAll(":", ",").split(",");
         const lat = Number(parts[0]);
         const lng = Number(parts[1]);

         if (Number.isFinite(lat) && Number.isFinite(lng)) {
            coordinates = { lat, lng, rowIndex };
         }
      }

      this.setState((prevState) => {
         const prevCoords = prevState.selectedRowCoordinates || [];
         if (isAdding && coordinates) {
            return { selectedRowCoordinates: [...prevCoords, coordinates] };
         } else {
            return {
               selectedRowCoordinates: prevCoords.filter((c) => c.rowIndex !== rowIndex),
            };
         }
      });
   };

   handleAddRow = () => {
      if (!this.hasAddItemForm()) {
         return;
      }
      this.setState({
         addRowModalOpen: true,
      });
   };

   renderFilteredRows(rows) {
      rows.forEach((row) => {
         if (Array.isArray(row.api_performerstatus)) {
            const performerStatus = row.api_performerstatus[0];
            row.api_performerstatus = performerStatus;
         }
         if (Array.isArray(row.api_instancestatus)) {
            row.api_instancestatus = row.api_instancestatus[0]?.name;
         }
      });
      return rows;
   }

   isThereHeaderBtns = () => {
      return (
         (!this.props?.showMap && this.getSerieSetting("showProfileFilter")) ||
         this.props.role === "OWNER" ||
         this.props.role === "MODERATOR" ||
         this.getSerieSetting("showDragModeSwitch") ||
         this.getSerieSetting("isDownloadable") ||
         this.getSerieSetting("isCsvDownloadable") ||
         this.getSerieSetting("showListTitle")
      );
   };

   renderAddRowHeader = () => {
      return (
         <div className="list-widget-table-header-actions">
            <Button buttonType="primary" onClick={this.handleAddRow} className="add-button">
               <Icon_Plus2 fill="var(--btn-primaryText)" />
            </Button>
         </div>
      );
   };

   renderColumnsWithCheckbox = () => {
      const { selectedRowKeys, rows, meta, columns: preparedColumns } = this.state;

      const isCheckbox =
         meta?.hasCheckboxColumn ||
         preparedColumns?.some((col) => col.label.toLowerCase() === "api_checkbox");

      const allSelected =
         rows.length > 0 &&
         rows.every((row) => selectedRowKeys.includes(row.api_rowMetaData.recordId));

      const someSelected = rows.some((row) =>
         selectedRowKeys.includes(row.api_rowMetaData.recordId),
      );

      const prepareColumnsWithoutAPICheckbox = preparedColumns.filter(
         (col) => col.label !== "api_checkbox",
      );

      const columns = [
         prepareColumnsWithoutAPICheckbox[0],
         ...(isCheckbox
            ? [
                 {
                    title: (
                       <Checkbox
                          checked={allSelected}
                          indeterminate={!allSelected && someSelected}
                          onChange={(e) => this.handleSelectAll(e.target.checked)}
                       />
                    ),
                    dataIndex: "api_checkbox",
                    key: "api_checkbox",
                    label: "api_checkbox",
                    hidden: false,
                    visible: 1,
                    sort: 1,
                    align: "center",
                    render: (_text, row) => (
                       <Checkbox
                          checked={selectedRowKeys.includes(row.api_rowMetaData.recordId)}
                          onChange={(e) =>
                             this.handleSelectOne(row.api_rowMetaData.recordId, e.target.checked)
                          }
                       />
                    ),
                 },
              ]
            : []),
         ...prepareColumnsWithoutAPICheckbox.slice(1),
      ];

      return columns;
   };

   render() {
      const { selectedRowKeys, selectedSerie } = this.state;
      const { listWidgetSeries } = this.props;
      const selectedSerieObj = this.getSerieById(selectedSerie);

      const showListTitle = this.getSerieSetting("showListTitle");
      return (
         <div
            ref={this.widgetRef}
            className={ListScripts.getWidgetClass(
               showListTitle,
               this.props?.showMap,
               this.getSerieSetting("isListHeaderFixed"),
            )}
         >
            <Widget
               title={[
                  showListTitle && this.state.name,
                  listWidgetSeries &&
                     ListScripts.getOnlyNotTechnicalSeries(listWidgetSeries)?.length > 1 && (
                        <ListSerieSelector
                           key="listSelector"
                           selectedSerieObj={selectedSerieObj}
                           listWidgetSeries={listWidgetSeries}
                           handleSerieChange={this.handleSerieChange}
                        />
                     ),
               ]}
               bgColor={this.props.backgroundColourHex}
               extra={
                  this.isThereHeaderBtns() && (
                     <ListExtraSettings
                        transport={this.state.transport}
                        selectedSerieObj={selectedSerieObj}
                        isCSVDownloadable={this.getSerieSetting("isCsvDownloadable")}
                        profiles={this.state.listProfiles}
                        showDragModeSwitch={this.getSerieSetting("showDragModeSwitch")}
                        setDraggableMode={this.setDraggableMode}
                        listProps={this.props}
                        selectedSerie={this.state.selectedSerie}
                        columns={this.state.columns}
                        isDownloadable={this.getSerieSetting("isDownloadable")}
                        downloadPDF={this.downloadPDF}
                        selectedRowKeys={selectedRowKeys}
                        setProfile={this.setProfile}
                        selectedProfile={this.state.profileSelection}
                        isProfileSelectorVisible={this.getSerieSetting("showProfileFilter")}
                        visibleRows={ListScripts.getFilteredRows(this.state.rows)}
                        visibleColumns={ListScripts.renderVisibleCols(
                           this.state.columns,
                           this.getSerieSetting,
                           this.renderEditableRows,
                           this.props.intl,
                           this.getSerieSetting("isListHeaderFixed"),
                           this.props.widgetId,
                        )}
                     />
                  )
               }
            >
               {this.props.showPlacefinder &&
                  (this.state.radius !== null && this.state.centerLocation !== null ? (
                     <Placefinder
                        refreshList={() => this.requestAndFillList({ force: true })}
                        radius={this.state.radius}
                        centerLocation={this.state.centerLocation}
                        isPlaceFinderChatOpen={this.state.isPlaceFinderChatOpen}
                        onJobRunningChange={this.setPlacefinderJobRunning}
                     />
                  ) : null)}
               {this.props?.showMap && (
                  <>
                     {/* {this.state.listWindow && (
                        <MapBottomList
                           pointName={this.state.pointName}
                           rows={this.state.rows}
                           props={this.props}
                           headerPosition={this.state.headerPosition}
                           getSerieSetting={this.getSerieSetting}
                           handleChangeTable={this.handleChangeTable}
                           visibleCols={ListScripts.renderVisibleCols(
                              this.state.columns,
                              this.getSerieSetting,
                              this.renderEditableRows,
                              this.props.intl
                           )}
                           switchToAllTaskSerie={this.switchToAllTaskSerie}
                           loading={this.state.loading}
                        />
                     )} */}
                     <div style={this.state.headerPosition === "top" ? { display: "none" } : {}}>
                        <div style={{ position: "relative" }}>
                           {this.props.showPlacefinder && (
                              <Button
                                 className="placefinder__button"
                                 buttonType={"secondary"}
                                 onClick={this.setIsPlaceFinderChatOpen}
                              >
                                 <Icon_Placefinder />
                              </Button>
                           )}
                           <MapComponent
                              listProps={this.props}
                              listState={this.state}
                              height={this.state.mapHeight}
                              listWindow={this.state.listWindow}
                              setCustomFilter={this.setCustomFilter}
                              selectedSerieObj={selectedSerieObj}
                              switchToWindowTaskSerie={this.switchToWindowTaskSerie}
                              handleSerieChange={this.handleSerieChange}
                              markerList={ListScripts.createGroupedPinMarkersList(
                                 this.state.mapMarkers,
                                 this.props.localizationFieldName,
                              )}
                              profileButtonClickHandler={this.setProfile}
                              listActions={this.responseData}
                              allActions={this.state.allActions}
                              handleChangeRadius={this.handleChangeRadius}
                              isMapInteractionLocked={this.state.isPlacefinderJobRunning}
                              selectedRowCoordinates={this.state.selectedRowCoordinates}
                           />
                        </div>
                     </div>
                  </>
               )}
               {this.state.totalItems !== null && this.state.listWindow === false ? (
                  <>
                     {selectedSerieObj ? (
                        <SummaryLabel
                           dataSource={
                              this.state.filteredRows?.length > 0
                                 ? this.state.filteredRows
                                 : this.state.rows
                           }
                           columnProperties={selectedSerieObj.columnProperties}
                           selectedSerie={this.state.selectedSerie}
                        />
                     ) : null}
                     {this.getSerieSetting("showSerieNameHeader") === true ? (
                        <ListSerieNameHeader
                           handleMapHeight={this.handleMapHeight}
                           selectedSerieObj={selectedSerieObj}
                           showMap={this.props?.showMap}
                           headerPosition={this.state.headerPosition}
                           toggleMap={this.toggleMap}
                        />
                     ) : null}
                     {this.state.isOpenList && (
                        <>
                           <DndProvider backend={HTML5Backend}>
                              {(() => {
                                 const visibleCols = ListScripts.renderVisibleCols(
                                    this.renderColumnsWithCheckbox(),
                                    this.getSerieSetting,
                                    this.renderEditableRows,
                                    this.props.intl,
                                    this.getSerieSetting("isListHeaderFixed"),
                                    this.props.widgetId,
                                 );

                                 const dataForTable = ListScripts.getFilteredRows(this.state.rows);

                                 return (
                                    <ListGridNavWrapper
                                       formId={this.state.formId}
                                       listId={selectedSerieObj.listId}
                                       actions={this.state.actions}
                                       handleListResponse={this.handleListResponse}
                                       dataSource={dataForTable}
                                       columns={visibleCols}
                                       fullColumns={this.state.columns}
                                       isMenuOpen={false}
                                       closeOpenMenu={undefined}
                                       onToggleActions={undefined}
                                       onRowClick={this.handleRowClick}
                                       mapIsDisplay={this.props.showMap}
                                       tableProps={{
                                          style: { paddingBottom: "25px" },
                                          filter: true,
                                          scroll: this.getSerieSetting("isListHeaderFixed")
                                             ? { y: 500, x: "auto" }
                                             : {},
                                          rowKey: (record, idx) =>
                                             record?._sysRecordId ?? record?.key ?? idx,
                                          className: ListScripts.getTableClass(
                                             true,
                                             this.props?.showMap,
                                             this.getSerieSetting,
                                             this.state.headerPosition,
                                          ),
                                          bordered: true,
                                          pagination: false,
                                          size: "medium",
                                          showHeader: this.getSerieSetting("showTableHeader"),
                                          rowClassName: ListScripts.getRowClass(
                                             this.getSerieSetting,
                                          ),
                                          loading: !!this.state.loading,
                                          onChange: this.handleChangeTable,
                                          components: this.state.draggableMode
                                             ? this.components
                                             : undefined,
                                          onRow: this.state.draggableMode
                                             ? (_, index) => ({
                                                  index,
                                                  moveRow: this.moveRow,
                                               })
                                             : null,
                                          title: this.hasAddItemForm()
                                             ? this.renderAddRowHeader
                                             : undefined,
                                       }}
                                    />
                                 );
                              })()}
                           </DndProvider>

                           <div className="list-widget-pagination-wrapper">
                              <div className="list-widget-spacer" />
                              <Pagination
                                 customClassName="gx-flex-row gx-justify-content-center gx-align-items-center gx-mt-2"
                                 initialPage={this.state.page}
                                 totalItems={this.state.totalItems}
                                 defaultPageSize={
                                    listWidgetSeries ? +selectedSerieObj.itemsPerPage : 4
                                 }
                                 onChange={(pageNumber) => {
                                    const nextPage = Math.max(1, Number(pageNumber) || 1);
                                    if (nextPage !== this.state.page) {
                                       this.setState({ loading: true, page: nextPage });
                                    }
                                 }}
                              />
                              {typeof this.props.authUser !== "number" && (
                                 <div className="list-widget-export-container">
                                    <ExcelExportButton listId={selectedSerieObj.listId} />
                                 </div>
                              )}
                           </div>
                        </>
                     )}
                  </>
               ) : (
                  <>
                     {this.state.listWindow === false ? (
                        <Card className="gx-card">
                           <Spin />
                        </Card>
                     ) : null}
                  </>
               )}
               {selectedSerieObj.listId.toString().length > 10 ? (
                  <FormV3InModal
                     formId={this.state.addItemFormId}
                     saveCallback={() => this.setState({ addRowModalOpen: false })}
                     setIsOpen={() =>
                        this.setState({ addRowModalOpen: !this.state.addRowModalOpen })
                     }
                     isOpen={this.state.addRowModalOpen}
                  />
               ) : (
                  <Modal
                     isOpen={this.state.addRowModalOpen}
                     onCancel={() => this.setState({ addRowModalOpen: false })}
                     topBarStyles={{ border: "none", padding: "10px" }}
                     width={1000}
                     height={700}
                     mainStyles={{ borderRadius: "15px", resize: "none" }}
                     footerContent={
                        <Button
                           className="cloud-list__cancel-btn"
                           buttonType="third"
                           onClick={() => this.setState({ addRowModalOpen: false })}
                        >
                           <IntlMessages id="Cancel" />
                        </Button>
                     }
                  >
                     {this.state.addItemFormId && (
                        <FormComplete
                           formId={this.state.addItemFormId}
                           saveCallback={() => {
                              this.setState({ addRowModalOpen: false });

                              Message.destroy();
                              Message.success(
                                 this.props.intl.formatMessage({
                                    id: "addRecordBtn.newOptionHasBeenAdded",
                                 }),
                                 5000,
                              );

                              this.requestAndFillList({ force: true });
                           }}
                           errorCallback={() => {
                              Message.error(intl.formatMessage({ id: "error.saveFailed" }));
                           }}
                        />
                     )}
                  </Modal>
               )}
            </Widget>
         </div>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      currentSheet: state.boards.sheet,
      currentLocation: state.user.currentLocation,
      board: state.boards.currentBoard,
      searchParams: state.settings.search,
      authUser: state.auth,
   };
};
export default injectIntl(connect(mapStateToProps, { setClickedRow })(CloudList));
